import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import 'url-search-params-polyfill'
import { MODAL_STATES, HOME, PATHS, LOAD } from 'src/config/app'
import Env from 'src/config/env'

// URL PARAMS
let urlParams = new window.URLSearchParams(window.location.search)

// DEBUG
let debug = process.env.NODE_ENV !== 'production'
// debug = false
if (urlParams.get('_debug') !== null) debug = true
if (urlParams.get('_debug') === 'false') debug = false


let reduced_motion = null
if (urlParams.get('_reduced_motion') !== null) reduced_motion = true


// STATE
const state = {

  debug: debug, 

  // Version
  version: {
    build: 1000,
    date: null,
  },

  // LOADING
  loading: {
    state: LOAD.STATES.FRAMEWORK_LOADING,
    progress: 0 // across all states 
  },

  // ROUTE
  route: {
    afterLoad: '/', // default page to show after loading
    curr: {
      parent: null,
      child: null,
    },
    prev: {
      parent: null,
      child: null,
    },
  },

  // reduced motion
  reduced_motion: reduced_motion,
  motion_clamp: 1,

  landingCopy: '',


  modal_state: MODAL_STATES.NONE,

  menu: {
    camera: {
      position: {
        x: -1.9,
        y: 0,
        z: 3.2
      },
      rotation: {
        x: -2,
        y: -320,
        z: 0
      },
      fov: 60
    }
  },

  video_overlay: {
    videoId: ''
  },

  home: {
 
    mode: HOME.MODES.DEFAULT,

    current_section: null,
    prev_section: null,
    section_index: 0, 
    scrollLock: false,
    dir: 0, // -1 : up, 0 : idle, 1 : down 
    sections: [
      { 
        title: 'welcome',
        id: HOME.SECTIONS.WELCOME,
        active: false,
        morphIndex: 0,
        index: 0,
        camera: {
          position: { 
            x: 0.1,
            y: 1.2,
            z: 1.8
          },
          rotation: {
            x: 0,
            y: 270,
            z: 0 
          },
          fov: 60
        }, 
        bubble: {
          displacement: {
            density: 0.6,
            amt: 0.07,
            speed: 0.2 
          } 
        },

        mobile: {
          camera: {
            position: { 
              x: 0,
              y: 1.4,
              z: 3.5
            },
            rotation: {
              x: 0,
              y: 270,
              z: 0 
            },
            fov: 60
          }
        } 
      },
      {
        title: '5 star',
        id: HOME.SECTIONS.STAR_RATING_FIVE, 
        morphIndex: 0,
        route: `#/${PATHS.RATING_FIVE}`,
        index: 1,
        bgColors: {
          startColor: '#191b44',
          stopColor: '#4046b0'
        },
        camera: {
          position: {
            x: 1.6,
            y: 0.2,
            z: 4
          },
          rotation: {
            x: 0,
            y: -40,
            z: 0
          },
          fov: 55
        },
        bubble: {
          displacement: {
            density: 0.8,
            amt: 0.065,
            speed: 0.2
          } 
        },

        mobile: {
          camera: {
            position: {
              x: 0.3,
              y: -0.6,
              z: 4.5
            },
            rotation: {
              x: -5,
              y: -30,
              z: 0
            },
            fov: 55
          }
        } 
      },
      { 
        title: '4 star',
        id: HOME.SECTIONS.STAR_RATING_FOUR, 
        morphIndex: 1,
        route: `#/${PATHS.RATING_FOUR}`,
        index: 2,
        bgColors: {
          startColor: '#1e265f',
          stopColor: '#3646b1' 
        },
        camera: {
          position: {
            x: -1,
            y: 0,
            z: 2.7
          },
          rotation: {
            x: -2,
            y: -320,
            z: 0
          },
          fov: 57
        },
        bubble: {
          displacement: {
            density: 0.7,
            amt: 0.075,
            speed: 0.2
          } 
        },

        mobile: {
          camera: {
            position: {
              x: -0.2,
              y: -0.6,
              z: 4.5
            },
            rotation: {
              x: -2,
              y: -320,
              z: 0
            },
            fov: 57
          }
        }
      },
      { 
        title: '3 star',
        id: HOME.SECTIONS.STAR_RATING_THREE, 
        morphIndex: 2,
        route: `#/${PATHS.RATING_THREE}`,
        index: 3,
        bgColors: {
          startColor: '#13193f',
          stopColor: '#3646b1' 
        },
        camera: {
          position: {
            x: 1 ,
            y: 0,
            z: 2.7
          },
          rotation: {
            x: -5,
            y: 10,
            z: 7
          },
          fov: 60
        },
        bubble: {
          displacement: {
            density: 0.6,
            amt: 0.075,
            speed: 0.2
          } 
        }, 

        mobile: {
          camera: {
            position: {
              x: 0.15 ,
              y: -0.6,
              z: 4
            },
            rotation: {
              x: -15,
              y: 320,
              z: -15
            },
            fov: 60
          }
        }
      },
      { 
        title: '2 star',
        id: HOME.SECTIONS.STAR_RATING_TWO, 
        morphIndex: 3,
        route: `#/${PATHS.RATING_TWO}`,
        index: 4,
        bgColors: {
          startColor: '#131940',
          stopColor: '#3241a5' 
        },
        camera: {
          position: {
            x: -1.2,
            y: 0,
            z: 2.2
          },
          rotation: {
            x: -5,
            y: 400,
            z: -8
          },
          fov: 65
        },
        bubble: {
          displacement: {
            density: 0.5,
            amt: 0.08,
            speed: 0.2
          } 
        }, 
        mobile: {
          camera: {
            position: {
              x: 0.15, 
              y: -0.5,
              z: 2.8
            },
            rotation: {
              x: -8,
              y: -330,
              z: 25
            },
            fov: 65
          }
        } 
      },
      { 
        title: '1 star',
        id: HOME.SECTIONS.STAR_RATING_ONE, 
        morphIndex: 4,
        route: `#/${PATHS.RATING_ONE}`,
        index: 5,
        bgColors: {
          startColor: '#0f1333',
          stopColor: '#3240a4' 
        },
        camera: {
          position: {
            x: 1.3,
            y: 0,
            z: 2
          },
          rotation: {
            x: -3,
            y: -50,
            z: 10
          },
          fov: 70
        },
        bubble: {
          displacement: {
            density: 0.5,
            amt: 0.1,
            speed: 0.2
          } 
        },

        mobile: { 
          camera: {
            position: {
              x: -0.1,
              y: -0.5,
              z: 3
            },
            rotation: {
              x: -5,
              y: -15,
              z: -30
            },
            fov: 70
          }
        }
      },
      { 
        title: 'cta', 
        id: HOME.SECTIONS.CTA ,
        index: 6,
        morphIndex: 4,
        camera: {
          position: { 
            x: 0.5,
            y: 0.5,
            z: 1.8
          },
          rotation: {
            x: 0,
            y: 180,
            z: 0 
          },
          fov: 60
        }, 
        bubble: {
          displacement: {
            density: 0.6,
            amt: 0.001,
            speed: 0.2
          } 
        },

        mobile: {
          camera: {
            position: { 
              x: 0.5,
              y: 0.5,
              z: 2
            },
            rotation: {
              x: 0,
              y: 180,
              z: 0 
            },
            fov: 60
          }
        }
      } 
    ]
  }
}

// EXPORT
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
